import { render, staticRenderFns } from "./PendingAccounts.vue?vue&type=template&id=6ccc3bb7&"
import script from "./PendingAccounts.vue?vue&type=script&lang=js&"
export * from "./PendingAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports